import React from 'react';
import { Box } from '@material-ui/core';

import { guestProfileService, FormStatus, GuestProfile, GuestProfilesForms } from '@lib/state';
import {
  FormHub,
  FormSubmitButton,
  GuestInformationForm,
  ContactInformationForm,
  Feedback,
  ErrorDisplay,
  Section,
  AccountVerification,
  useFormEvents,
} from '@lib/common';

interface Props {
  guest: GuestProfile;
}

export const GuestProfileForm: React.FC<Props> = ({ guest }) => {
  const [{ status, error }, reset] = useFormEvents(GuestProfilesForms.UpdateProfile);

  const userId = guest.userId;
  return (
    <Section title="Guest Info" variant="contained" banner={<AccountVerification />}>
      <FormHub
        onSubmit={(guest: GuestProfile) => {
          guestProfileService.updateGuestProfile({ ...guest, userId });
        }}
      >
        <ContactInformationForm
          email={guest.contact.email}
          emailVerified={guest.emailVerfied}
          phone={guest.contact.phone}
          phoneVerified={guest.phoneNumberVerified}
          isEmailDisabled={true}
          inputProps={{
            InputLabelProps: { shrink: true },
          }}
        />
        <GuestInformationForm
          name={guest.name}
          address={guest.address}
          allowNameChange={false}
          gender={guest.gender}
          language={guest.language}
          showPreferredTemperature
          preferredTemperature={guest.preferredTemperature}
          showArchived={false}
          inputProps={{
            InputLabelProps: { shrink: true },
          }}
        />
        <Box mt={1.5}>
          <Feedback show={status === FormStatus.Success} severity="success" onHide={reset}>
            Your guest profile has been updated successfully.
          </Feedback>
          <ErrorDisplay error={error} />
          <Box display="flex" justifyContent="flex-end">
            <FormSubmitButton size="small" color="secondary" variant="contained">
              Save
            </FormSubmitButton>
          </Box>
        </Box>
      </FormHub>
    </Section>
  );
};
